import React, {memo} from "react";

export const IconAim = memo(({color, addClass}) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      className={`${addClass ?? ""}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 1.04272C9.224 1.04272 9 1.26672 9 1.54272V5.54272C9 5.81872 9.224 6.04272 9.5 6.04272C9.776 6.04272 10 5.81872 10 5.54272V1.54272C10 1.26672 9.776 1.04272 9.5 1.04272Z"
        fill={color || "#000"}
      />
      <path
        d="M9.5 15.0427C9.224 15.0427 9 15.2667 9 15.5427V19.5427C9 19.8187 9.224 20.0427 9.5 20.0427C9.776 20.0427 10 19.8187 10 19.5427V15.5427C10 15.2667 9.776 15.0427 9.5 15.0427Z"
        fill={color || "#000"}
      />
      <path
        d="M5 10.5427C5 10.2667 4.776 10.0427 4.5 10.0427H0.5C0.224 10.0427 0 10.2667 0 10.5427C0 10.8187 0.224 11.0427 0.5 11.0427H4.5C4.776 11.0427 5 10.8187 5 10.5427Z"
        fill={color || "#000"}
      />
      <path
        d="M18.5 10.0427H14.5C14.224 10.0427 14 10.2667 14 10.5427C14 10.8187 14.224 11.0427 14.5 11.0427H18.5C18.776 11.0427 19 10.8187 19 10.5427C19 10.2667 18.776 10.0427 18.5 10.0427Z"
        fill={color || "#000"}
      />
      <path
        d="M16.2101 9.04265C15.9941 9.04265 15.7961 8.90265 15.7311 8.68565C15.1031 6.57465 13.4681 4.93965 11.3571 4.31165C11.0921 4.23265 10.9421 3.95465 11.0201 3.68965C11.0981 3.42465 11.3771 3.27465 11.6421 3.35265C12.8291 3.70565 13.9221 4.35865 14.8031 5.23865C15.6841 6.11865 16.3361 7.21265 16.6891 8.39965C16.7681 8.66465 16.6171 8.94265 16.3521 9.02165C16.3041 9.03565 16.2561 9.04265 16.2091 9.04265H16.2101Z"
        fill={color || "#000"}
      />
      <path
        d="M11.5 17.7526C11.284 17.7526 11.086 17.6126 11.021 17.3956C10.942 17.1306 11.093 16.8526 11.358 16.7736C13.468 16.1456 15.103 14.5106 15.732 12.3996C15.811 12.1346 16.089 11.9846 16.354 12.0626C16.619 12.1406 16.769 12.4196 16.691 12.6846C16.338 13.8716 15.685 14.9646 14.805 15.8456C13.925 16.7266 12.832 17.3786 11.644 17.7316C11.596 17.7456 11.548 17.7526 11.501 17.7526H11.5Z"
        fill={color || "#000"}
      />
      <path
        d="M7.50004 17.7527C7.45304 17.7527 7.40504 17.7457 7.35704 17.7317C6.17004 17.3787 5.07704 16.7267 4.19604 15.8457C3.31504 14.9647 2.66304 13.8727 2.31004 12.6847C2.23104 12.4197 2.38204 12.1417 2.64704 12.0627C2.91204 11.9837 3.19004 12.1347 3.26904 12.3997C3.89704 14.5097 5.53204 16.1447 7.64304 16.7727C7.90804 16.8517 8.05804 17.1297 7.98004 17.3947C7.91504 17.6117 7.71604 17.7527 7.50104 17.7527H7.50004Z"
        fill={color || "#000"}
      />
      <path
        d="M2.79017 9.04277C2.74317 9.04277 2.69517 9.03577 2.64717 9.02177C2.38217 8.94277 2.23217 8.66477 2.31017 8.39977C2.66317 7.21277 3.31617 6.11977 4.19617 5.23877C5.07617 4.35777 6.16917 3.70577 7.35717 3.35277C7.62217 3.27377 7.90017 3.42477 7.97917 3.68977C8.05817 3.95477 7.90717 4.23277 7.64217 4.31177C5.53217 4.93977 3.89717 6.57477 3.26917 8.68577C3.20417 8.90277 3.00517 9.04377 2.79017 9.04377V9.04277Z"
        fill={color || "#000"}
      />
    </svg>
  );
});
